import { ResponseModel } from '../../../shared/models/reponse.model';
import { ResendUCMResponseDto } from '../dtos/resend-ucm-response.dto';

export class ResendUCMResponseModel extends ResponseModel {
    private _pac: string;

    public constructor(response: ResendUCMResponseDto) {
        super(response);
        this._pac = response.pac;
    }

    public get pac(): string {
        return this._pac;
    }
}
